export const SOCKET_CONSTANTS = {
  SUBSCRIPTION_CHANNEL: 'subscription',
  TICK_CHANNEL: 'T',
  NOTIFICATION_CHANNEL: 'N',
  DATA_CHANNEL: 'data',
  BOT_SUBSCRIPTION: 'bot_subscription',
};
